const server={
  url:"https://apiportalmanager.mayaland.store"         //PRODUCCION
}

export const elixir={
  url:"https://portalmanager.pro"
}
export default server